// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListResourceMetadataMessage } from './genericApiResponseListResourceMetadataMessage';
import type { GenericApiResponseListResourceMetadataPagination } from './genericApiResponseListResourceMetadataPagination';
import type { GenericApiResponseListResourceMetadataData } from './genericApiResponseListResourceMetadataData';

export interface GenericApiResponseListResourceMetadata {
  success?: boolean;
  message?: GenericApiResponseListResourceMetadataMessage;
  pagination?: GenericApiResponseListResourceMetadataPagination;
  data?: GenericApiResponseListResourceMetadataData;
}
